import { useAuth } from "@/components/AuthProvider";
import { Smartphone } from "lucide-react";

export const MobileUploadView = () => {
  return (
    <div className="min-h-screen bg-[#F8F9FA] p-4 flex items-center justify-center">
      <div className="w-full max-w-md text-center space-y-4">
        <div className="flex justify-center">
          <Smartphone className="h-16 w-16 text-purple-500" />
        </div>
        <h1 className="text-2xl font-semibold text-gray-900">
          Mobile Version Coming Soon
        </h1>
        <p className="text-gray-600">
          Please use a larger screen for the complete studio experience. We're working on making this available on mobile devices.
        </p>
      </div>
    </div>
  );
};